// import { Button, CircularProgress, makeStyles } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, makeStyles } from "@mui/material";

function PrimaryButton({ children, large, ...props }) {
  return <Button {...props}>{children}</Button>;
}

export default PrimaryButton;
